import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate, Outlet } from 'react-router-dom'

export const AuthRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    isAuthenticated ?
      <Navigate to={`/dashboard`} /> :
      <Outlet />
  );
};